'use strict';

class Button extends Widget {
  _element: any;
  _text: any;

  constructor(element: any) {
    super(element);
    this._element.click(this._onClicked.bind(this));

    let text = this._element.text();
    this._text = $('<div class="text">' + text + '</div>');
    this._element.html('');
    this._element.append(this._text);
  }

  text(text: any) {
    if (text === undefined) {
      return this._text.text();
    } else {
      this._text.text(text);
    }
  }

  active(active?: any) {
    if (active === undefined) {
      return this._element.hasClass('active');
    } else if (active !== this.active()){
      this._element.toggleClass('active');
    }
  }

  click() {
    this._onClicked();
  }

  _onClicked() {
    this.emit('clicked');
  }

  static Create() {
    return $('<div class="button" />');
  }
}

ui.Button = Button;
ui.button = ui.widgetConstructor('button', ui.Button);
